import { render, staticRenderFns } from "./shareFrom.vue?vue&type=template&id=0bbbb70b&scoped=true&"
import script from "./shareFrom.vue?vue&type=script&lang=js&"
export * from "./shareFrom.vue?vue&type=script&lang=js&"
import style0 from "./shareFrom.vue?vue&type=style&index=0&id=0bbbb70b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbbb70b",
  null
  
)

export default component.exports